import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
// import { HttpLink } from 'apollo-link-http'
import { BatchHttpLink } from 'apollo-link-batch-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

Vue.use(VueApollo)

function createApolloProvider (uri) {
  // const link = new HttpLink({uri})
  const link = new BatchHttpLink({uri})

  const apolloClient = new ApolloClient({
    link,
    cache: new InMemoryCache(),
    connectToDevTools: true
  })

  const apolloProvider = new VueApollo({
    defaultClient: apolloClient
  })

  return apolloProvider
}

export default createApolloProvider



// WEBPACK FOOTER //
// ./src/apollo.js